/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
  BookmakerDTO,
  EventDTO,
  MatchOddsDTO,
  SecondaryMarkets,
  getFormattedMinLimit,
  getFormattedMaxLimit,
} from "@hypexone/uicore";

import MatchOdds from "../all-markets/match-odds/MatchOdds";
import { fetchEventMarkets } from "@hypexone/uicore";
import Bookmaker from "../all-markets/bookmaker/Bookmaker";
import { websocketService } from "../../../webSocket/SocketServices";

interface MultiMarketsProps {
  loggedIn: boolean;
  eventData: EventDTO;
  secondaryMatchOdds: MatchOddsDTO[];
  secondaryMarkets: SecondaryMarkets;
  bmMData: BookmakerDTO[];
  isMultiMarket: boolean;
  exposureMap: any;
  topicUrls: Record<string, any>;
  setBetStartTime?: any;
  setAddNewBet?: any;
}

const MultiMarkets: React.FC<MultiMarketsProps> = ({
  loggedIn,
  eventData,
  secondaryMatchOdds,
  secondaryMarkets,
  bmMData,
  isMultiMarket,
  exposureMap,
  topicUrls,
  setBetStartTime,
  setAddNewBet,
}) => {
  const { betFairWSConnected } = useAppSelector((state) => state.catalog);

  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>("");
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>("");
  const [bookMakerBaseUrl, setBookMakerBaseUrl] = useState<string>("");
  const [bookMakerTopic, setBookMakerTopic] = useState<string>("");

  const updateMatchOddsTopic = (currentTopic, currentBaseUrl) => {
    if (
      matchOddsTopic !== currentTopic ||
      matchOddsBaseUrl !== currentBaseUrl
    ) {
      websocketService.disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  };

  const updateBookMakerTopic = (currentTopic, currentBaseUrl) => {
    if (
      bookMakerTopic !== currentTopic ||
      bookMakerBaseUrl !== currentBaseUrl
    ) {
      websocketService.disconnectToWS();
      setBookMakerTopic(currentTopic);
      setBookMakerBaseUrl(currentBaseUrl);
    }
  };

  useEffect(() => {
    websocketService.unsubscribeAllWsforEvents();
  }, []);

  // Websocket handler
  useEffect(() => {
    if (loggedIn && topicUrls?.matchOddsBaseUrl) {
      if (betFairWSConnected) {
        websocketService.disconnectToWS();
      }
      const baseUrlsPayload = {
        matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
        bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
        premiumBaseUrl: topicUrls?.premiumBaseUrl,
      };
      websocketService.connectToWS(baseUrlsPayload);

      return () => {
        if (betFairWSConnected) {
          websocketService.disconnectToWS();
        }
      };
    }
  }, [loggedIn, topicUrls]);

  useEffect(() => {
    if (loggedIn && eventData) {
      if (topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl,
        );
        websocketService.subscribeWsForEventOdds(
          topicUrls?.matchOddsTopic,
          eventData?.sportId,
          eventData?.competitionId,
          eventData?.eventId,
          eventData?.matchOdds?.marketId,
          eventData?.providerName,
          true,
        );
      }

      if (
        eventData?.sportId === "4" ||
        eventData?.sportId === "2" ||
        eventData?.sportId === "1" ||
        eventData?.sportId === "99990" ||
        eventData?.sportId === "99994" ||
        eventData?.sportId === "2378961" ||
        eventData?.sportId === "other"
      ) {
        if (secondaryMarkets?.bookmakers?.length && topicUrls?.bookMakerTopic) {
          updateBookMakerTopic(
            topicUrls?.bookMakerTopic,
            topicUrls?.bookMakerBaseUrl,
          );
          for (const itm of secondaryMarkets?.bookmakers ?? []) {
            websocketService.subscribeWsForSecondaryMarkets(
              topicUrls?.bookMakerTopic,
              eventData?.eventId,
              itm?.marketId,
              eventData?.sportId,
              eventData?.competitionId,
              true,
            );
          }
        }
      }

      if (topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl,
        );
        for (const mo of secondaryMatchOdds ?? []) {
          websocketService.subscribeWsForSecondaryMatchOdds(
            topicUrls?.matchOddsTopic,
            eventData?.eventId,
            mo?.marketId,
          );
        }
      }
    }
  }, [betFairWSConnected, loggedIn, secondaryMatchOdds, secondaryMarkets]);

  useEffect(() => {
    if (loggedIn) {
      if (topicUrls?.matchOddsBaseUrl) {
        const baseUrlsPayload = {
          matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
          bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
          premiumBaseUrl: topicUrls?.premiumBaseUrl,
        };
        websocketService.checkStompClientSubscriptions(baseUrlsPayload);
      }
    }
  }, []);

  return (
    <>
      {eventData ? (
        <>
          {/* <div className="multi-market-eventname mob-view">
            {
              isMobile && multiMarketData?.filter(i => i?.marketId === eventData?.matchOdds?.marketId).length > 0 ?
                eventData?.eventName
                : null
            }
          </div> */}
          {eventData?.matchOdds?.runners?.length > 0 && (
            <MatchOdds
              exposureMap={exposureMap ? exposureMap : null}
              loggedIn={loggedIn}
              getFormattedMinLimit={getFormattedMinLimit}
              getFormattedMaxLimit={getFormattedMaxLimit}
              eventData={eventData}
              secondaryMatchOdds={secondaryMatchOdds}
              isMultiMarket={isMultiMarket}
              showMatchOdds={true}
              showSecondaryMatchOdds={true}
              setBetStartTime={setBetStartTime}
              setAddNewBet={setAddNewBet}
            />
          )}
          {secondaryMarkets?.bookmakers?.length > 0 &&
          (secondaryMarkets?.bookmakers?.[0]?.runners?.length ?? 0) > 0 ? (
            <Bookmaker
              loggedIn={loggedIn}
              getFormattedMinLimit={getFormattedMinLimit}
              getFormattedMaxLimit={getFormattedMaxLimit}
              bmData={bmMData}
              eventData={eventData}
              isMultiMarket={isMultiMarket}
              exposureMap={exposureMap ? exposureMap : null}
              setBetStartTime={setBetStartTime}
              setAddNewBet={setAddNewBet}
              loading={false}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default MultiMarkets;
